// Demo-data voor de "Nieuw project"-tour: faked PDF upload + AI parse zodat
// werknemers de stap-2 (items review) en stap-3 (matching review) UI's live
// kunnen zien zonder echt te uploaden.
//
// De tour activeert dit via window.__recotexTour.activateDemo() — ProjectNew
// hooked die functie aan zijn state-setters bij mount.
import type { ParsedItem, MatchedLine, MeerwerkLine, SkippedItem, ReviewItem, Pricelist, ChargeLine } from '@recotex/shared';

export const DEMO_PRICELIST_ID = '__demo_pricelist__';
export const DEMO_PLOEG_ID = '__demo_ploeg__';

export const DEMO_PRICELIST: Pricelist = {
  id: DEMO_PRICELIST_ID,
  name: 'DEMO Prijslijst',
  description: 'Tijdelijke prijslijst voor de rondleiding',
  currency: 'EUR',
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
  items: [
    { id: 'demo-i-1', pricelistId: DEMO_PRICELIST_ID, pdfNaam: 'PLAATSEN PIR ISOLATIE 10CM', eenheid: 'M2',   naamArbeid: 'PLAATSEN PIR ISOLATIE 10CM',   prijs: 12.50, isNvt: false, sortOrder: 0 },
    { id: 'demo-i-2', pricelistId: DEMO_PRICELIST_ID, pdfNaam: 'HANGGOOT ZINK VIERKANT',    eenheid: 'LM',   naamArbeid: 'HANGGOOT ZINK VIERKANT',      prijs: 35.00, isNvt: false, sortOrder: 1 },
    { id: 'demo-i-3', pricelistId: DEMO_PRICELIST_ID, pdfNaam: 'VERWIJDEREN DAKBEDEKKING',  eenheid: 'M2',   naamArbeid: 'VERWIJDEREN DAKBEDEKKING',    prijs:  8.50, isNvt: false, sortOrder: 2 },
    { id: 'demo-i-4', pricelistId: DEMO_PRICELIST_ID, pdfNaam: 'PLAATSING PANLATTEN',       eenheid: 'M2',   naamArbeid: 'PLAATSING PANLATTEN',         prijs:  5.00, isNvt: false, sortOrder: 3 },
    { id: 'demo-i-5', pricelistId: DEMO_PRICELIST_ID, pdfNaam: 'KILGOTEN AFWERKING ZINK',   eenheid: 'LM',   naamArbeid: 'KILGOTEN AFWERKING ZINK',     prijs: 22.00, isNvt: false, sortOrder: 4 },
  ],
};

export const DEMO_PLOEG = {
  id: DEMO_PLOEG_ID,
  team: 'DEMO',
  firma: 'Demo Onderaannemer (tour)',
  email: '',
  telefoon: '',
  pricelistId: DEMO_PRICELIST_ID,
  bouwflowId: null,
  createdAt: new Date().toISOString(),
};

export const DEMO_META = {
  klantNaam: 'Familie Demo',
  klantAdres: 'Demostraat 42, 9000 Gent',
  adviseur: 'Test Adviseur',
  projectTitel: 'Demo — Hellend dak renovatie',
  projectNummer: 'P-DEMO',
  opmerkingen: 'Dit project is fictief, gemaakt door de rondleiding.\nGeen echte facturatie — wordt verwijderd bij stoppen.',
};

export const DEMO_PARSED_ITEMS: ParsedItem[] = [
  { id: 'demo-p-1', categorie: 'ISOLATIE',         werken: 'Plaatsen PIR Isolatie 10cm',          geadviseerdeHoeveelheid: 100, werkelijkeHoeveelheid: 105, eenheid: 'M2' },
  { id: 'demo-p-2', categorie: 'REGENWATER',       werken: 'Hanggoot Zink Vierkant',              geadviseerdeHoeveelheid: 12,  werkelijkeHoeveelheid: 12,  eenheid: 'LM' },
  { id: 'demo-p-3', categorie: 'AFBRAAK',          werken: 'Verwijderen bestaande dakbedekking',  geadviseerdeHoeveelheid: 95,  werkelijkeHoeveelheid: 98,  eenheid: 'M2' },
  { id: 'demo-p-4', categorie: 'TIMMERWERKEN',     werken: 'Speciaal pakket dakkapel afwerking',  geadviseerdeHoeveelheid: 1,   werkelijkeHoeveelheid: 1,   eenheid: 'STUK' },
];

export const DEMO_MATCHED_LINES: MatchedLine[] = [
  {
    id: 'demo-ml-1',
    naamArbeid: 'PLAATSEN PIR ISOLATIE 10CM',
    eenheid: 'M2', prijs: 12.50, hoeveelheid: 105, subtotaal: 1312.50,
    consumedParsedItemIds: ['demo-p-1'], autoMatched: true,
    subItems: [{
      parsedItemId: 'demo-p-1', pdfNaam: 'Plaatsen PIR Isolatie 10cm', plItemId: 'demo-i-1',
      hoeveelheid: 105, eenheid: 'M2', prijs: 12.50, subtotaal: 1312.50, confidence: 1.0, autoMatched: true,
    }],
  },
  {
    id: 'demo-ml-2',
    naamArbeid: 'HANGGOOT ZINK VIERKANT',
    eenheid: 'LM', prijs: 35.00, hoeveelheid: 12, subtotaal: 420.00,
    consumedParsedItemIds: ['demo-p-2'], autoMatched: true,
    subItems: [{
      parsedItemId: 'demo-p-2', pdfNaam: 'Hanggoot Zink Vierkant', plItemId: 'demo-i-2',
      hoeveelheid: 12, eenheid: 'LM', prijs: 35.00, subtotaal: 420.00, confidence: 1.0, autoMatched: true,
    }],
  },
];

// 1 item in review-queue (fuzzy match, score 0.75 — gebruiker moet bevestigen)
export const DEMO_REVIEW_ITEMS: ReviewItem[] = [
  {
    parsedItem: DEMO_PARSED_ITEMS[2]!,
    suggestions: [{ item: DEMO_PRICELIST.items![2]!, score: 0.75 }],
  },
];

// 1 fully unmatched — geen suggesties, gebruiker kiest manueel of meerwerk
export const DEMO_UNMATCHED_ITEMS: ReviewItem[] = [
  {
    parsedItem: DEMO_PARSED_ITEMS[3]!,
    suggestions: [],
  },
];

export const DEMO_MEERWERK_LINES: MeerwerkLine[] = [];
export const DEMO_SKIPPED_ITEMS: SkippedItem[] = [];
export const DEMO_CHARGE_LINES: ChargeLine[] = [];

export const DEMO_PARSE_RESULT = {
  meta: { ...DEMO_META, teamNaam: 'DEMO' },
  items: DEMO_PARSED_ITEMS,
  matching: {
    matchedLines: DEMO_MATCHED_LINES,
    meerwerkLines: DEMO_MEERWERK_LINES,
    skippedItems: DEMO_SKIPPED_ITEMS,
    reviewItems: DEMO_REVIEW_ITEMS,
    unmatchedItems: DEMO_UNMATCHED_ITEMS,
  },
  totals: { subtotaal: 1732.50, meerwerk: 0, aanrekening: 0, totaal: 1732.50 },
  ploeg: { id: DEMO_PLOEG_ID, team: 'DEMO', firma: 'Demo Onderaannemer (tour)' },
  pricelistId: DEMO_PRICELIST_ID,
  pdfFilename: 'demo-opstartfiche.pdf',
  pdfStorageKey: null,
};
